import { motion } from "framer-motion";
import { useEffect } from "react";

type Props = {};

const GrammifyPPPage = (props: Props) => {
  useEffect(() => {
    document.title = "Grammify Privacy Policy";
  }, []);

  return (
    <div className="flex relative overflow-y-scroll overflow-x-hidden gap-y-10 flex-col no-scrollbar items-center justify-center bg-gradient-to-br from-slate-800 via-slate-950 to-slate-800">
      <motion.div
        className="max-w-4xl mx-auto p-6 bg-slate-800 shadow-md rounded-md my-8 text-slate-100"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.h1
          className="text-3xl font-bold mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Privacy Policy for Grammify
        </motion.h1>

        <motion.p
          className="text-slate-200 font-semibold text-lg mb-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Last updated: January 1, 2025
        </motion.p>

        <motion.section
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <h2 className="text-2xl font-semibold mb-2">1. Introduction</h2>
          <p className="text-slate-200 font-semibold text-lg">
            Welcome to Softwarify’s Grammify application. We value your privacy
            and are committed to protecting your personal information. This
            Privacy Policy outlines how we collect, use, and safeguard your data
            when you use our app.
          </p>
        </motion.section>

        <motion.section
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          <h2 className="text-2xl font-semibold mb-2">
            2. Information We Collect
          </h2>
          <ul className="list-disc list-inside text-slate-200 font-semibold text-lg">
            <li>
              Personal Information: Such as your name, email address, and
              contact details when you register.
            </li>
            <li>
              Usage Data: Information on how you use Grammify, including
              features accessed and time spent.
            </li>
            <li>
              Device Information: Details about the device you use to access the
              app, including IP address and operating system.
            </li>
          </ul>
        </motion.section>

        <motion.section
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.0 }}
        >
          <h2 className="text-2xl font-semibold mb-2">
            3. How We Use Your Information
          </h2>
          <ul className="list-disc list-inside text-slate-200 font-semibold text-lg">
            <li>To provide and maintain our service.</li>
            <li>To improve and personalize your experience with Grammify.</li>
            <li>
              To communicate with you, including responding to your inquiries.
            </li>
            <li>To monitor and analyze usage and trends to enhance our app.</li>
          </ul>
        </motion.section>

        <motion.section
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          <h2 className="text-2xl font-semibold mb-2">
            4. Data Sharing and Disclosure
          </h2>
          <p className="text-slate-200 font-semibold text-lg">
            We do not sell, trade, or otherwise transfer your personal
            information to outside parties except as described in this Privacy
            Policy. This does not include trusted third parties who assist us in
            operating our app, conducting our business, or servicing you, so
            long as those parties agree to keep this information confidential.
          </p>
        </motion.section>

        <motion.section
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4 }}
        >
          <h2 className="text-2xl font-semibold mb-2">5. Data Security</h2>
          <p className="text-slate-200 font-semibold text-lg">
            We implement a variety of security measures to maintain the safety
            of your personal information. However, no method of transmission
            over the Internet or electronic storage is 100% secure, and we
            cannot guarantee absolute security.
          </p>
        </motion.section>

        <motion.section
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.6 }}
        >
          <h2 className="text-2xl font-semibold mb-2">6. Your Rights</h2>
          <p className="text-slate-200 font-semibold text-lg">
            You have the right to access, correct, or delete your personal
            information. You can do this by contacting us through the
            information provided below.
          </p>
        </motion.section>

        <motion.section
          className="mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.8 }}
        >
          <h2 className="text-2xl font-semibold mb-2">
            7. Changes to This Privacy Policy
          </h2>
          <p className="text-slate-200 font-semibold text-lg">
            We may update our Privacy Policy from time to time. Any changes will
            be posted on this page with an updated revision date. We encourage
            you to review this Privacy Policy periodically for any changes.
          </p>
        </motion.section>

        <motion.section
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2.0 }}
        >
          <h2 className="text-2xl font-semibold mb-2">8. Contact Us</h2>
          <p className="text-slate-200 font-semibold text-lg">
            If you have any questions about this Privacy Policy, please contact
            us at:
          </p>
          <p className="text-slate-200 font-semibold text-lg">
            <strong>Softwarify</strong>
            <br />
            Email: sio@softwarify.co - aak@softwarify.co
            <br />
            Address: İstanbul, Ataşehir, Türkiye
          </p>
        </motion.section>
      </motion.div>
    </div>
  );
};

export default GrammifyPPPage;
